import logo from "./logo.svg";
import "./App.css";
import {buildQuestion} from "./util"

function App() {
  let questions = buildQuestion();
  return (
    <div className="App columns-2 w-3/4 content-center m-auto mt-1">
      {questions.map((item) => (
        <div className="p-3.5">
          {item[0]} {item[1]} {item[2]} =
        </div>
      ))}
    </div>
  );
}

export default App;
